"use client"
import React, { useState } from "react";
import "./ContactPage.css";
import emailIcon from "../../assets/mail.svg";
import phoneIcon from "../../assets/phoneIcon.png";
import addressIcon from "../../assets/officeIcon.png";
import TextFade from "../../components/CustomTexts/TextFade";
import Button from "../../components/Buttons/Button";
import TextEffect from '../../components/CustomTexts/TextEffect';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState(""); // ✅ success/error feedback

  const handleChange = (e: { target: { name: any; value: any; }; }) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: { preventDefault: () => void; }) => {
    e.preventDefault();

    const { name, email, message } = formData;

    if (!name || !email || !message) {
      setStatus("❌ Please fill in all fields before submitting.");
      return;
    }

 try {
  // Prepare mailto link
  const subject = encodeURIComponent("Contact Form Message");
  const body = encodeURIComponent(
    `Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`
  );

  // Send to both emails
  window.location.href = `mailto:info@simdoziinternationaltd.com,simdozi.internationaltd@gmail.com?subject=${subject}&body=${body}`;

      setStatus("✅ Message ready to send via your email client.");
    } catch (error) {
      console.error(error);
      setStatus("⚠️ Something went wrong. Please try again.");
    }
  };

  return (
    <div className="flex md:flex-row flex-col">
      <div className="bg-dark md:w-[60%] w-full py-[20vh] md:px-[8%] px-[5%]">
        <TextFade animation="fade-down">
          <h1 className="md:text-[60px] text-[30px] font-bold text-white text-center">
            <TextEffect text="Contact Us" />
          </h1>
        </TextFade>
        <p className="text-white md:text-[20px] text-[14px] w-full text-center">
          We'd love to hear from you! Whether you have a question about our
          services, need assistance with a project, or want to provide feedback,
          our team is here to help.
        </p>

        {/* FORM */}
        <form className="mt-20 flex flex-col gap-10" onSubmit={handleSubmit}>
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="border-secondary border bg-secondary/15 py-5 px-4 rounded-[8px] outline-secondary placeholder:text-white text-white focus:outline-none"
            type="text"
            placeholder="Full Name"
          />
          <input
            name="email"
            value={formData.email}
            onChange={handleChange}
            type="email"
            placeholder="Email Address"
            className="border-secondary border bg-secondary/15 py-5 px-4 rounded-[8px] outline-secondary placeholder:text-white text-white focus:outline-none"
          />
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Write a message"
            className="border-secondary border bg-secondary/15 py-5 px-4 rounded-[8px] outline-secondary placeholder:text-white text-white focus:outline-none"
            rows={10}
          ></textarea>

          <div className="flex items-center justify-center w-full mt-10">
            <Button type="submit" value="Submit" />
          </div>
        </form>

        {/* Status Feedback */}
        {status && (
          <p className="text-center mt-5 text-white font-semibold">
            {status}
          </p>
        )}
      </div>

      {/* CONTACT INFO (unchanged) */}
      <div className=" bg-white flex flex-col gap-20 md:w-[40%] w-full py-[20vh] px-[5%]">
        <div className="flex flex-col md:flex-row md:items-start  bg-dark py-5 px-10 rounded-[8px] items-center gap-7">
          <img src={emailIcon} alt="Email Icon" />
          <div className="flex flex-col items-start justify-start ">
            <p className="mb-3 text-white font-bold text-[20px]">Email Address</p>
            <a href="mailto:simdozi.internationaltd@gmail.com" className="text-light">simdozi.internationaltd@gmail.com</a>
            <a href="mailto:info@simdoziinternationaltd.com" className="text-light">info@simdoziinternationaltd.com</a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-start bg-dark py-5 px-10 rounded-[8px] items-center gap-7">
          <img src={phoneIcon} alt="Phone Icon" />
          <div>
            <p className="mb-3 text-white font-bold text-[20px]">Phone Number</p>
            <a href="tel:+2347044449882" className="text-light">
              +234 (809) 1399 850 <br /> +234 (803) 5564 010
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-start bg-dark py-5 px-10 rounded-[8px] items-center gap-7">
          <img src={addressIcon} alt="Address Icon" />
          <div>
            <p className="mb-3 text-white font-bold text-[20px]">Registered Office Address</p>
            <p className="text-light">No. 1 Abdou Diof Street, Asokoro, Abuja</p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-start bg-dark py-5 px-10 rounded-[8px] items-center gap-7">
          <img src={addressIcon} alt="Address Icon" />
          <div>
            <p className="mb-3 text-white font-bold text-[20px]">Operational Office</p>
            <p className="text-light">Plot 21, APDC Capital Estate, Kubwa Express Way, Abuja</p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-start bg-dark py-5 px-10 rounded-[8px] items-center gap-7">
          <img src={addressIcon} alt="Address Icon" />
          <div>
            <p className="mb-3 text-white font-bold text-[20px]">Farm Address</p>
            <p className="text-light">Kilometre 21, Keffi – Abuja Express Way, Uke, Karu LGA, Nasarawa State</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
